import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ToolboxRedoNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M21.6449 8.23822L20.9095 3.09052L15.8183 8.18172L20.966 8.91712C21.362 8.97372 21.7015 8.63422 21.6449 8.23822Z"
        fill={color}
      />
      <path
        d="M6.9094 6.90822L4.3641 4.36292C2.3239 6.40312 1.2 9.11602 1.2 12C1.2 14.884 2.3238 17.5969 4.3641 19.6359L6.9094 17.0906C5.5489 15.7312 4.8 13.923 4.8 12C4.8 10.077 5.5488 8.26872 6.9094 6.90822Z"
        fill={color}
      />
      <path
        d="M17.0906 17.0906C14.3718 19.8094 9.6305 19.8094 6.9093 17.0906L4.364 19.6359C6.4031 21.6773 9.116 22.8 11.9999 22.8C14.8838 22.8 17.5968 21.6773 19.6358 19.6359L17.0906 17.0906Z"
        fill={color}
      />
      <path
        d="M12 1.20001C9.116 1.20001 6.4031 2.32261 4.3641 4.36291L6.9094 6.90821C9.6282 4.18941 14.3719 4.18941 17.0907 6.90821L19.636 4.36291C17.5969 2.32261 14.8851 1.20001 12 1.20001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolboxRedoNsk.displayName = 'ToolboxRedoNsk';
